import { Pipe, PipeTransform } from "@angular/core";
import { Session } from "@webapp/sessions/models/sessions.model";

@Pipe({
  name: "filter",
})
export class SessionsFilterByTitlePipe implements PipeTransform {
  public transform(sessions: Session[], query: string): Session[] {
    if (!sessions) return [];
    if (!query) return sessions;

    return sessions.filter((session) => {
      return session.title.toLowerCase().includes(query.toLocaleLowerCase());
    });
  }
}
